export const featureIDs = [
    'api_destinations',
    'automations_disabled',
    'calendly_integration',
    'campaigns_disabled',
    'campaign_filtering',
    'contact_groups',
    'external_contact_lists',
    'flows',
    'hubspot_integration',
    'hybrid_message_routing',
    'message_hub_ai',
    'new_billing_implementation',
    'notifications',
    'quick_blast_ai',
    'salesforce_integration',
    'sentiment_analysis_ai',
    'shift_to_text',
    'simple_message_hub',
    'single_sign_on',
    'subscriptions',
    'time_zone_aware_campaigns',
    'transactional_default',
] as const;

export type FeatureID = (typeof featureIDs)[number];
export type Features = Record<FeatureID, boolean>;
